import React, { useState } from 'react';

import { Layer } from '../Layer';

const LayerBranch = ({
  currentLayer,
  layer,
  namePrefix,
  level,
  onLayerClick,
}: {
  currentLayer: any;
  layer: any;
  namePrefix: any;
  level: any;
  onLayerClick: any;
}) => {
  const [open, setOpen] = useState(layer.open || false);

  const hasChildren = layer.children && layer.children.length !== 0;

  const handleLayerArrowClick = (event: any) => {
    event.stopPropagation();

    setOpen((prevOpen: any) => !prevOpen);
  };

  const _renderLayerBranches = () => {
    if (hasChildren) {
      const nextLevel = level + 1;

      return layer.children.map((child: any, childIndex: any) => (
        <LayerBranch
          key={child.id}
          namePrefix={`${namePrefix}.children[${childIndex}]`}
          layer={child}
          currentLayer={currentLayer}
          level={nextLevel}
          onLayerClick={onLayerClick}
        />
      ));
    }
  };

  return (
    <>
      <Layer
        hasChildren={hasChildren}
        open={open}
        current={currentLayer?.id === layer.id}
        namePrefix={namePrefix}
        layer={layer}
        level={level}
        onArrowClick={handleLayerArrowClick}
        onClick={onLayerClick}
      />
      {open && _renderLayerBranches()}
    </>
  );
};

export default React.memo(LayerBranch) as any;
